<div class="container-fluid g-0 m-0">
  <div class="d-flex g-0 m-0">
    <div class="sidemenu-nav background-color">
      <h6 class="sidemenu-title">
        {{ "SIDEBAR_ONDEMANDDATAREAD" | translate | uppercase }}
      </h6>
      @if (
        authService.isAuthorized([PermissionsEnum.Ondemand_loadprofile_view])
      ) {
        <div
          class="sidemenu-item-font item"
          (click)="navigate('on-demand/load-profile')"
          [ngClass]="{ selected: isActive('on-demand/load-profile') }"
        >
          <span>{{ "LOADPROFILEMANU_GETLOADPROFILE" | translate }}</span>
        </div>
      }
      @if (
        authService.isAuthorized([PermissionsEnum.Ondemand_energyregister_view])
      ) {
        <div
          class="sidemenu-item-font item"
          (click)="navigate('on-demand/energy')"
          [ngClass]="{ selected: isActive('on-demand/energy') }"
        >
          <span>{{ "GETENERGYREGISATER" | translate }}</span>
        </div>
      }
      @if (
        authService.isAuthorized([
          PermissionsEnum.Ondemand_powerdemandregister_view,
        ])
      ) {
        <div
          class="sidemenu-item-font item"
          (click)="navigate('on-demand/power-demand')"
          [ngClass]="{ selected: isActive('on-demand/power-demand') }"
        >
          <span>{{ "LOADPROFILEMANU_MAXDEMANDREGISTRES" | translate }}</span>
        </div>
      }
      @if (
        authService.isAuthorized([
          PermissionsEnum.Ondemand_instantaneousobject_view,
        ])
      ) {
        <div
          class="sidemenu-item-font item"
          (click)="navigate('on-demand/instantaneous-object')"
          [ngClass]="{ selected: isActive('on-demand/instantaneous-object') }"
        >
          <span>{{ "LOADPROFILEMANU_INSTANTANEUSOBJECT" | translate }}</span>
        </div>
      }
      @if (
        authService.isAuthorized([
          PermissionsEnum.Ondemand_generic_register_view,
        ])
      ) {
        <div
          class="sidemenu-item-font item"
          (click)="navigate('on-demand/custom-register')"
          [ngClass]="{ selected: isActive('on-demand/custom-register') }"
        >
          <span>{{ "LOADPROFILEMENU_CUSTOMREGISTER" | translate }}</span>
        </div>
      }
      @if (authService.isAuthorized([PermissionsEnum.Ondemand_event_log_view])) {
        <div
          class="sidemenu-item-font item"
          (click)="navigate('on-demand/event-log')"
          [ngClass]="{ selected: isActive('on-demand/event-log') }"
        >
          <span>{{ "EVENTLOGMENU_GETEVENTLOG" | translate }}</span>
        </div>
      }
    </div>
    <div class="sidemenu-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
